<template>
  <div class="right_col" role="main">
    <div class="hidden-print">
      <div class="page-title">
        <div class="title_left">
          <h3>
            {{
              $t('operationalManagementPage.qrCodeDisplayForSeatAuthorization')
            }}
          </h3>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div class="x_panel">
            <h2>
              {{ $t('common.shopName') }}：
              <strong>{{ name }}</strong>
            </h2>
            <div class="x_content">
              <alert
                :title="title"
                :success-message="$t('common.isSuccess')"
                :error-message="$t('common.isFailure')"
                :alerts="alerts"
                :errors="errors"
                :display="alertDisplay"
                @closeAlert="closeAlert"
              />
              <div class="text-right">
                <button
                  v-if="allClick"
                  @click="allCheck"
                  class="btn btn-default"
                >
                  {{ $t('operationalManagementPage.wholeDeselection') }}
                </button>
                <button v-else @click="allCheck" class="btn btn-default">
                  {{ $t('operationalManagementPage.wholeSelection') }}
                </button>
                <button @click="printQr" class="btn btn-primary">
                  {{ $t('operationalManagementPage.printSelectedQr') }}
                </button>
              </div>
              <div v-if="isJp" class="row" style="margin: 20px 0 0">
                <div class="col-md-12 col-sm-12 col-xs-12 text-center">
                  <div class="btn-group" data-toggle="buttons">
                    <label
                      :class="{ 'btn-info active': activeTab === 'new' }"
                      class="btn btn-default"
                    >
                      <input
                        id="option1"
                        @click="selectTab('new')"
                        type="radio"
                        name="options"
                      />
                      {{
                        $t('operationalManagementPage.soWebSupportedVersion')
                      }}
                    </label>
                    <label
                      :class="{ 'btn-info active': activeTab === 'old' }"
                      class="btn btn-default"
                    >
                      <input
                        id="option2"
                        @click="selectTab('old')"
                        type="radio"
                        name="options"
                      />
                      {{ $t('operationalManagementPage.appVersion') }}
                    </label>
                  </div>
                </div>
              </div>
              <div
                v-if="activeTab === 'new'"
                class="row"
                style="margin: 20px 0 0"
              >
                <div
                  v-for="(item, key) in seatQrListForWeb"
                  :key="key"
                  class="col-md-55 thumbnail-wrapper"
                >
                  <div class="thumbnail">
                    <div v-if="item.path" class="image view view-first">
                      <img
                        :src="item.path"
                        :alt="
                          `${$t('operationalManagementPage.seatNumber')}:${
                            item.number
                          }${$t('operationalManagementPage.ofQrCode')}`
                        "
                      />
                    </div>
                    <div v-else class="image view view-first">
                      <h3>
                        {{ $t('operationalManagementPage.seatNumber') }}：{{
                          item.number
                        }}
                        <strong>{{
                          $t('operationalManagementPage.qrCodeUnset')
                        }}</strong>
                      </h3>
                    </div>
                    <div class="caption text-center">
                      <p>
                        <label :for="'qr' + item.number">
                          <input
                            :id="'qr' + item.number"
                            v-model="item.checked"
                            @click="seatCheck(item.number)"
                            type="checkbox"
                            name="qr"
                            value="ski"
                            data-parsley-mincheck="1"
                            class="flat"
                          />
                          {{ $t('operationalManagementPage.shopNumber') }}:{{
                            shopId
                          }}/{{ name }}/{{
                            $t('operationalManagementPage.seatNumber')
                          }}：{{ item.number }}
                        </label>
                      </p>
                      <p>
                        <button
                          @click="changeQr(item.number)"
                          class="btn-sm btn-primary"
                        >
                          {{ $t('operationalManagementPage.changeQr') }}
                        </button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="isJp && activeTab === 'old'"
                class="row"
                style="margin: 20px 0 0"
              >
                <div
                  v-for="(item, key) in seatQrList"
                  :key="key"
                  class="col-md-55 thumbnail-wrapper"
                >
                  <div class="thumbnail">
                    <div v-if="item.path" class="image view view-first">
                      <img
                        :src="item.path"
                        :alt="
                          `${$t('operationalManagementPage.seatNumber')}:${
                            item.number
                          }${$t('operationalManagementPage.ofQrCode')}`
                        "
                      />
                    </div>
                    <div v-else class="image view view-first">
                      <h3>
                        {{ $t('operationalManagementPage.seatNumber') }}：{{
                          item.number
                        }}
                        <strong>{{
                          $t('operationalManagementPage.qrCodeUnset')
                        }}</strong>
                      </h3>
                    </div>
                    <div class="caption text-center">
                      <p>
                        <label :for="'qr' + item.number">
                          <input
                            :id="'qr' + item.number"
                            v-model="item.checked"
                            @click="seatCheck(item.number)"
                            type="checkbox"
                            name="qr"
                            value="ski"
                            data-parsley-mincheck="1"
                            class="flat"
                          />
                          {{ $t('operationalManagementPage.shopNumber') }}:{{
                            shopId
                          }}/{{ name }}/{{
                            $t('operationalManagementPage.seatNumber')
                          }}：{{ item.number }}
                        </label>
                      </p>
                      <p>
                        <button
                          @click="changeQr(item.number)"
                          class="btn-sm btn-primary"
                        >
                          {{ $t('operationalManagementPage.changeQr') }}
                        </button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ln_solid"></div>
              <div class="form-group">
                <div class="text-right">
                  <router-link to="/setting/shop" class="btn btn-default">{{
                    $t('common.back')
                  }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="print-screen">
      <h2>
        {{ $t('common.shopName') }}：
        <strong>{{ name }}</strong>
      </h2>
      <div v-if="activeTab === 'new'">
        <p>{{ $t('operationalManagementPage.soWebSupportedVersion') }}</p>
        <div class="row">
          <div
            v-for="(item, key) in seatQrListForWeb"
            :key="key"
            class="col-md-3"
          >
            <div v-if="item.checked" :id="'seat' + item.number" class="qr-box">
              <div class="image">
                <img
                  v-if="item.path"
                  :src="item.path"
                  :alt="
                    `${$t('operationalManagementPage.seatNumber')}:${
                      item.number
                    }${$t('operationalManagementPage.ofQrCode')}`
                  "
                />
                <img
                  v-else
                  :alt="
                    `${$t('operationalManagementPage.seatNumber')}:${
                      item.number
                    }${$t('operationalManagementPage.qrCodeUnset')}`
                  "
                  src
                />
              </div>
              <div>
                {{ $t('operationalManagementPage.shopNumber') }}:{{ shopId }}/{{
                  name
                }}/{{ $t('operationalManagementPage.seatNumber') }}：{{
                  item.number
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <p>{{ $t('operationalManagementPage.appVersion') }}</p>
        <div class="row">
          <div v-for="(item, key) in seatQrList" :key="key" class="col-md-3">
            <div v-if="item.checked" :id="'seat' + item.number" class="qr-box">
              <div class="image">
                <img
                  v-if="item.path"
                  :src="item.path"
                  :alt="
                    `${$t('operationalManagementPage.seatNumber')}:${
                      item.number
                    }${$t('operationalManagementPage.ofQrCode')}`
                  "
                />
                <img
                  v-else
                  :alt="
                    `${$t('operationalManagementPage.seatNumber')}:${
                      item.number
                    }${$t('operationalManagementPage.qrCodeUnset')}`
                  "
                  src
                />
              </div>
              <div>
                {{ $t('operationalManagementPage.shopNumber') }}:{{ shopId }}/{{
                  name
                }}/{{ $t('operationalManagementPage.seatNumber') }}：{{
                  item.number
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <footer-item />
      </div>
    </div>
  </div>
</template>
<style scoped>
.thumbnail {
  height: auto;
}
.thumbnail img {
  margin: 0 auto;
  display: block;
  width: 120px;
  height: 120px;
}
.thumbnail label,
.btn-sm {
  cursor: pointer;
  font-weight: normal;
}

@media print {
  .print-screen .image {
    border: solid 1px #ccc;
    padding: 5px;
    width: 130px;
    height: 130px;
  }

  .print-screen .qr-box {
    width: 130px;
    margin-bottom: 10px;
  }
}

@media screen {
  .print-screen {
    display: none;
  }
}
</style>
<script>
import Alert from '@/components/common/alert/Alert'
import Footer from '@/components/common/footer/Footer'
import ShopRequest from '@/http/ShopRequest'
import { mapGetters } from 'vuex'
import alert from '@/mixin/alert'

export default {
  components: {
    Alert,
    FooterItem: Footer,
  },
  mixins: [alert],
  data() {
    return {
      title: this.$t('operationalManagementPage.qrCodeChange'),
      shopData: {},
      name: '',
      seatQrList: [],
      seatQrListForWeb: [],
      seatCount: 0,
      shopId: String,
      allClick: false,
      activeTab: 'new',
    }
  },
  computed: {
    ...mapGetters({
      fetchedData: 'qr/getQr',
      getShopById: 'shop/getShopById',
    }),
    isJp() {
      return process.env.VUE_APP_LANG === 'ja'
    },
  },
  watch: {
    fetchedData: function(newFetchedData) {
      this.shopId = this.$route.params.id
      this.name = newFetchedData.shopname
      this.seatQrList = [...Array(this.seatCount)].map((_, index) => ({
        number: index + 1,
        path: newFetchedData.seatQrList[index + 1] || '',
        checked: false,
      }))
      this.seatQrListForWeb = [...Array(this.seatCount)].map((_, index) => ({
        number: index + 1,
        path: newFetchedData.seatQrListForWeb[index + 1] || '',
        checked: false,
      }))
    },
  },
  mounted() {
    const shop = this.getShopById(this.$route.params.id)
    this.seatCount = shop.seatCount
    this.$store.dispatch('qr/getQr', { id: this.$route.params.id })
  },
  methods: {
    selectTab: function(value) {
      this.activeTab = value
    },
    allCheck: function() {
      if (this.allClick) {
        this.seatQrList.forEach((seatQr) => {
          seatQr.checked = false
        })
        this.seatQrListForWeb.forEach((seatQrForWeb) => {
          seatQrForWeb.checked = false
        })
        this.allClick = false
      } else {
        this.seatQrList.forEach((seatQr) => {
          seatQr.checked = true
        })
        this.seatQrListForWeb.forEach((seatQrForWeb) => {
          seatQrForWeb.checked = true
        })
        this.allClick = true
      }
    },
    seatCheck: function(number) {
      const index = this.seatQrList.findIndex(
        (seatQr) => seatQr.number === number
      )
      this.seatQrList[index].checked = !this.seatQrList[index].checked
      this.seatQrListForWeb[index].checked = !this.seatQrListForWeb[index]
        .checked
      this.$forceUpdate()
    },
    printQr: function() {
      const checked = this.seatQrList.filter((seatQr) => seatQr.checked)
      if (checked.length) {
        window.print()
      } else {
        this.title = this.$t('operationalManagementPage.qrCodeChange')
        this.openErrorAlert([
          [this.$t('operationalManagementPage.qrCodeIsUnselected')],
        ])
      }
    },
    changeQr: function(number) {
      const request = new ShopRequest()
      request
        .changeQr(this.$route.params.id, number)
        .then((res) => {
          const index = this.seatQrList.findIndex(
            (seatQr) => seatQr.number === number
          )
          this.seatQrList[index].path = res.data.qr
          this.seatQrListForWeb[index].path = res.data.qrForWeb
          this.openSuccessAlert()
        })
        .catch((err) => {
          this.openErrorAlert(err.response.data)
          console.log(err.response)
        })
        .finally(() => {
          this.title = this.$t('operationalManagementPage.qrCodeChange')
        })
    },
  },
}
</script>
